"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactJss = require("react-jss");

var _CSSTransiton = _interopRequireDefault(require("../CSSTransiton"));

var useStyles = (0, _reactJss.createUseStyles)({
  menu: {
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: 0,
    marginBottom: 0,
    listStyleType: 'none'
  }
});

var Menu = function Menu(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      maxHeight = _ref.maxHeight,
      row = _ref.row,
      animation = _ref.animation,
      collapse = _ref.collapse,
      innerClassName = _ref.innerClassName,
      dense = _ref.dense;
  var classes = useStyles();
  var propStyle = maxHeight ? {
    maxHeight: collapse ? 0 : maxHeight,
    opacity: collapse ? 0 : 1
  } : {
    maxHeight: 'auto',
    overflowY: 'hidden'
  };
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames["default"])(className, classes.menu, 'box-shadow-mid-lighter', 'w-fill', {
      'p-4': !dense
    }),
    style: (0, _extends2["default"])({}, style, propStyle),
    "data-qa": "menu"
  }, /*#__PURE__*/_react["default"].createElement(_CSSTransiton["default"], {
    animation: animation,
    show: !collapse
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('d-flex-fill', !row ? 'flex-column' : 'flex-row-wrap', innerClassName)
  }, children)));
};

Menu.defaultProps = {
  className: '',
  animation: null,
  style: {},
  maxHeight: null,
  row: false,
  collapse: false,
  innerClassName: '',
  dense: false
};
Menu.propTypes = {
  /** Child items in the menu component */
  children: _propTypes["default"].node.isRequired,

  /** Additional class for root level */
  className: _propTypes["default"].string,

  /** Additional style for root level */
  style: _propTypes["default"].shape(),

  /** Max height for menu component - overflowY added */
  maxHeight: _propTypes["default"].number,

  /** Indicator whether or not we want menu as row or column */
  row: _propTypes["default"].bool,

  /** Animation to apply to menu level */
  animation: _propTypes["default"].string,

  /** Indicator whether or not menu should be collapsed */
  collapse: _propTypes["default"].bool,

  /** Menu inner class */
  innerClassName: _propTypes["default"].string,

  /** Remove padding on menu */
  dense: _propTypes["default"].bool
};
var _default = Menu;
exports["default"] = _default;